import { Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { SettingsCustomFormsView } from './customForms.view';
import { FormsEditPage } from './views/formsEditPage/formsEditPage';

const SettingsCustomFormsRoutes = (): JSX.Element | null => {
  const { hasCustomFormsFeature } = useFeatureFlag([
    'has-custom-forms-feature',
  ]);

  if (!hasCustomFormsFeature) {
    return null;
  }

  return (
    <Routes>
      <Route index element={<SettingsCustomFormsView />} />
      <Route path="edit/:formId" element={<FormsEditPage />} />
    </Routes>
  );
};

export const settingsCustomFormsRoutes = (
  <Route path="custom-forms/*" element={<SettingsCustomFormsRoutes />} />
);
